import type { FaireOrderEntity } from "../../entity_types/order";

export const E6GEG47RDV: FaireOrderEntity = {
  token: "E6GEG47RDV",
  type: "order",
  orderNumber: "#E6GEG47RDV",
  status: "unfulfilled",
  totalDollars: 15,
  customerName: "Coastline Curios & Co.",
  firstOrder: false,
  placedAt: "Dec 1, 2025",
  shipBy: "Jan 3, 2026",
  sourceLabel: "Faire Direct",
  payoutDate: "Pending Ship",
  hasInvoice: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
